module.exports = __webpack_public_path__ + "362a6b5bc094aaba049555732ee33f4a.png";


//////////////////
// WEBPACK FOOTER
// ./assets/images/patches/wings/solo-left-1.png
// module id = 3168
// module chunks = 0